import { render, staticRenderFns } from "./RfxStatusBar.vue?vue&type=template&id=0130a82b"
import script from "./RfxStatusBar.vue?vue&type=script&lang=js"
export * from "./RfxStatusBar.vue?vue&type=script&lang=js"
import style0 from "./RfxStatusBar.vue?vue&type=style&index=0&id=0130a82b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports